"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _Base = _interopRequireDefault(require("../Base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    sideBar: {
      width: "40%",
      maxWidth: 500
    }
  };
});
/**
* General Moment for integrating a sidebar `Drawer` component with a Moment.
*/

function SideBarMoment(props) {
  var children = props.children,
      layout = props.layout,
      onClose = props.onClose,
      sidebar = props.sidebar,
      sideBarClassName = props.sideBarClassName,
      sideBarContent = props.sideBarContent,
      type = props.type;
  var classes = useStyles();
  var drawerPaperClasses = (0, _utils.classList)(classes.sideBar, sideBarClassName);
  return _react.default.createElement(_Base.default, props, _react.default.createElement(_core.CssBaseline, null), _react.default.createElement("main", null, children), _react.default.createElement(_core.Drawer, {
    anchor: "right",
    open: sidebar,
    onClose: onClose,
    classes: {
      paper: drawerPaperClasses
    }
  }, sideBarContent));
}

;
SideBarMoment.propTypes = _defineProperty({
  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** The layout name of the `Moment` */
  type: _propTypes.default.string,

  /** Determines if the `Drawer` is visible. */
  sidebar: _propTypes.default.bool.isRequired,

  /** Class name for the `SideBar` `Drawer` root. */
  sideBarClassName: _propTypes.default.string,

  /** Determines the content in the `Drawer` body of the `Moment`. */
  sideBarContent: _propTypes.default.any,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node
}, "type", _propTypes.default.string);
SideBarMoment.defaultProps = {
  layout: "sidebar",
  sidebar: false,
  type: "sidebar"
};
var _default = SideBarMoment;
exports.default = _default;